<template>
  <div class="d-flex">
    <div
      v-for="index in loop"
      :key="index"
      @click="handlePress(index - 1)"
      :disabled="disabled"
      class="me-1"
      :class="{ 'cursor-pointer': !disabled }"
    >
      <i class="fas fa-star" :class="[isSolid(index), size]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    color?: string;
    size?: string;
    loop?: number;
    value?: number;
    disabled?: boolean;
  }>(),
  {
    color: "text-warning",
    size: "",
    loop: 5,
    value: 0,
    disabled: false,
  },
);

const emit = defineEmits<{
  onClick: [rating: number];
}>();

const rating = ref(props.value);

const isSolid = (index: number): string =>
  rating.value >= index ? props.color : "text-primary25";

const handlePress = (index: number): void => {
  if (props.disabled) return;
  rating.value = rating.value === index + 1 ? index : index + 1;
  emit("onClick", rating.value);
};
</script>
